import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { ConnectedPartner } from '@savgroup-front-common/types/Onboarding/ConnectedPartner';

const ENDPOINT = `${APIConfiguration.seller}ConnectedPartner`;

interface UpsertConnectedPartnerCommandPayload {
  connectedPartner: ConnectedPartner;
}

const upsertConnectedPartnerCommand = async ({
  connectedPartner,
}: UpsertConnectedPartnerCommandPayload): Promise<
  BackResponse<ConnectedPartner[]> | BackResponseFailure
> => {
  try {
    const response = await apiCall<BackResponse<ConnectedPartner[]>>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: connectedPartner,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default upsertConnectedPartnerCommand;
